import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-opacity": ".7",
      d: "M12 3a9 9 0 1 1 0 18 9 9 0 1 1 0-18m0 1.256a7.744 7.744 0 1 0 0 15.488 7.744 7.744 0 0 0 0-15.488"
    }, null, -1)
  ]))]))
}
export default { render: render }